module.exports = __webpack_public_path__ + "static/media/undraw_calling_kpbp.68a733f6.svg";